import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import PrivacyPolicy from "./Screens/PrivacyPolicy";
import HomePage from "./Screens/HomePage";
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import ContactUs from "./Screens/ContactUs";

const root = ReactDOM.createRoot(document.getElementById('root'));


const router = createBrowserRouter([
    {
        path: "/",
        element: <HomePage/>,

    },
    {
        path: "/privacy-policy",
        element: <PrivacyPolicy/>,

    }, {
        path: "/contact-us",
        element: <ContactUs/>,

    },
]);
root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>

    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
